var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
var ConditionalLink = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, children = _a.children, className = _a.className, rest = __rest(_a, ["disabled", "onClick", "children", "className"]);
    if (disabled)
        return children;
    return (_jsx("a", __assign({}, rest, { onClick: onClick, className: classNames('bold clickable', className) }, { children: children })));
};
export default ConditionalLink;
